import {Proxy} from "../../../settings";
import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deletePurchase = async (id: number) =>
  baseDeleteRequest(`${Proxy}/purchase/${id}/`);

export default deletePurchase;
